import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ICity, IDropdown } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";

const schema = yup.object({
    city_Name: yup.string().required("City Name Type is required"),
    city_Desc: yup.string().nullable(),
 //   countryId: yup.number().required("Country is required").min(1, "Country is required"),
    state_ID: yup.number().required("State is required").min(1, "State is required"),
});

interface Iprops {
    singleData: ICity,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Form = (props: Iprops) => {
    const [countries, setCountries] = useState<IDropdown[]>();
    const [states, setStates] = useState<IDropdown[]>();
    const [submitting, setSubmitting] = useState(false);

    const { control, handleSubmit, watch, formState: { errors }, reset } = useForm<ICity>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    const countryId = watch("Country_ID");

    useEffect(() => {
        loadCountries();
    }, []);
    useEffect(() => {
        if (countryId) loadStates(countryId);
    }, [countryId]);

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);

    const loadCountries = async () => {
        const response = await Fetch("country/dropdown", "GET", null, null, null);
        if (response) {
            setCountries(await response.json());
        }
    }

    const loadStates = async (countryId: number) => {
        const response = await Fetch(`state/dropdown/${countryId}`, "GET", null, null, null);
        if (response) {
            setStates(await response.json());
        }
    }

    const saveToDB = async (body: ICity) => {
        setSubmitting(true);
        const method = props.singleData.id ? "PUT" : "POST";
        const message = props.singleData.id ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch(`city${props.singleData.id ? '/' + props.singleData.id : ''}`, method, body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.reloadData();
        }
        setSubmitting(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset({});
    }

    function onSubmit(data: any) {
        saveToDB(data);
    }
 
    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '400px' }} header="Add/Edit City" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <JVDropdown column={1} required label="Country" control={control} options={countries} optionLabel="country_Name" optionValue="id" name="Country_ID" placeholder="Select Country" error={errors.Country_ID?.message} />
                <JVDropdown column={1} required label="State" control={control} options={states} optionLabel="state_Name" optionValue="id" name="state_ID" placeholder="Select State" error={errors.state_ID?.message} />
                <JVInput column={1} required label="City Name" control={control} name="city_Name" error={errors.city_Name?.message} />
                <JVInput column={1} label="Description" control={control} name="city_Desc" error={errors.city_Desc?.message} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}